module.exports = __webpack_public_path__ + "353519fc6e9234cacd520b017e24f284.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/event-forecast.png
 ** module id = 1060
 ** module chunks = 0
 **/